import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";

function ProjectCards(props) {
  return (
    <Card className="project-card-view">
      <Card.Img variant="top" src={props.imgPath} alt="card-img" />
      <Card.Body>
        <Card.Title>{props.title}</Card.Title>
        <Card.Text style={{ textAlign: "center", paddingBottom: "25px" }}>
          {props.description}
        </Card.Text>
      </Card.Body>
      <div style={{ paddingBottom: "25px" }}></div>
    </Card>
  );
}
export default ProjectCards;
